import React from "react";
import PlaceholderPage from "./PlaceholderPage";

/** Placeholder page for XML/HTML sitemap generation and validation. */
const Sitemaps: React.FC = () => (
	<PlaceholderPage title="Sitemaps" description="Generate and validate XML/HTML sitemaps to keep search engines in sync." />
);

export default Sitemaps;

